import React, { Fragment, useEffect, useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Button, Switch } from "@material-ui/core";
import classNames from "classnames";
import LowerTermsUserRights from "./LowerTermsUserRights";
import { useTranslation } from "react-i18next";
import TLServiceComponent from "../../../../contexts/TLServiceComponent";
import { useSelector } from "react-redux";
import { useTheme } from "@material-ui/core/styles";
import style from "./style.module.sass";
import config from "../../../../config";
import { switchStyles } from "../../../../utils"

export default function LowerTermsModalFields({
  setUserId, setFirmaId, setGroupId,
  allowListDisabled, setAllowListDisabled,
  ignoreDisabled, setIgnoreDisabled,
  setColor, color,
  invisible, setInvisible,
  userId, groupId, firmaId,
  mainBox, setMainBox,
  setDeleteRight, deleteRight,
  categoryType
}) {
  const [activeTab, setActiveTab] = useState('1')
  const [user, setUser] = useState()
  const [group, setGroup] = useState()
  const [company, setCompany] = useState()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const isDark = themeState === config.THEMES_MODES.CONTRAST_DARK
  const { t } = useTranslation()
  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  }
  const tlService = React.useContext(TLServiceComponent);
  const token = useSelector(state => state.userData.token);
  const { theme: { bgColors, colors,borderColors } } = useTheme()
  const classes = switchStyles(bgColors, colors)()

  const getDatas = async () => {
    // Get all User:
    try {
      let user = await tlService.getUser(token, {}, {});
      let userIs = [];
      user.data.map(el => {
        let obj = {};
        obj.title = el.user_name;
        obj.id = el.id;
        userIs.push(obj)
      })
      setUser(userIs)
    } catch (err) {
      console.log('error', err)
    }
    // Get all Group:
    try {
      let group = await tlService.getFilteredGroups(token, {}, {});
      let groupIs = [];
      group.data.map(el => {
        let obj = {};
        obj.title = el.name;
        obj.id = el.id;
        groupIs.push(obj)
      })
      setGroup(groupIs)
    } catch (err) {
      console.log('error', err)
    }
    // Get all Company:
    try {
      let company = await tlService.getFilteredCompanies(token, {}, {});
      let companyIs = [];
      company.data.map(el => {
        let obj = {};
        obj.title = el.name;
        obj.id = el.id;
        companyIs.push(obj)
      })
      setCompany(companyIs)
    } catch (err) {
      console.log('error', err)
    }
    // Set Color according to TermList Type, if negative set color to red, if positive, to Green:
    if (color === "") {
      if (categoryType === "negative") {
        setColor("colorRed")
      } else if (categoryType === "positive") {
        setColor("colorGreen")
      }
    }
  }

  useEffect(() => {
    getDatas()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink style={{ cursor: "pointer", color: isDark && activeTab === '1' ? colors.colorTextReverse : colors.colorText }}
            className={classNames({ active: activeTab === '1' })}
            onClick={() => {
              toggle('1');
            }}
          >
            {t('user-rights')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink style={{ cursor: "pointer", color: isDark && activeTab === '2' ? colors.colorTextReverse : colors.colorText }}
            className={classNames({ active: activeTab === '2' })}
            onClick={() => {
              toggle('2');
            }}
          >
            {t('settings')}
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <div style={{ height: "400px", overflow: "scroll" }}>
            <LowerTermsUserRights
              deleteRight={deleteRight}
              setDeleteRight={setDeleteRight}
              mainBox={mainBox} setMainBox={setMainBox}
              user={user} group={group} company={company} setUserId={setUserId}
              setFirmaId={setFirmaId} setGroupId={setGroupId}
              userId={userId} groupId={groupId} firmaId={firmaId} />
          </div>
        </TabPane>
        <TabPane tabId="2">
          <table cellPadding={10}>
            <tbody>
              <tr>
                <th>
                  {t('settings')}
                </th>
                <th>{t('value')}</th>
              </tr>
              <tr>
                <td width={200}>
                  <b>
                    {t("AllowList Disabled")} :
                  </b>
                </td>
                <td>
                  <Switch
                    checked={!!allowListDisabled}
                    onChange={() => setAllowListDisabled(!allowListDisabled)}
                    inputProps={{ 'aria-label': 'controlled' }}
                    className={classes.root}
                  />
                </td>
              </tr>
              <tr>
                <td width={200}>
                  <b>
                    {t("Ignore Disabled")} :
                  </b>
                </td>
                <td>
                  <Switch
                    checked={!!ignoreDisabled}
                    onChange={() => setIgnoreDisabled(!ignoreDisabled)}
                    inputProps={{ 'aria-label': 'controlled' }}
                    className={classes.root}
                  />
                </td>
              </tr>
              {categoryType !== "allowedlist" ? <tr>
                <td width={200}>
                  <b>
                    {t("Color")} :
                  </b>
                </td>
                <td>
                  <div style={{ display: "flex" }}>
                    {
                      config.userSettingColor.map((list, key) => {
                        const isSelected = color === list["name"]
                        return !isContrast ? (
                          <span key={key} onClick={() => {
                            if (isSelected) {
                              setColor("")
                            } else {
                              setColor(list["name"])
                            }
                          }} style={{
                            borderColor: list["color"],
                            backgroundColor: (isSelected) ? list["color"] : bgColors.bgPrimary0
                          }} className={`mr-2 ${style.border}`}>
                          </span>
                        ) : (
                          <Button
                            key={key}
                            onClick={() => {
                              if (isSelected) {
                                setColor("")
                              } else {
                                setColor(list["name"])
                              }
                            }}
                            style={{backgroundColor: (isSelected) ? bgColors.bgAiBtnSelected : bgColors.bgAiBtn, color: (isSelected) ? colors.colorWhite : colors.colorMutedText, boxShadow: isSelected ? '0 0 5px rgba(0, 0, 0, 0.161)' : 'none', border: isSelected ? `1px solid ${borderColors.borderPrimary200}` : 'none', marginRight: '8px'}}>
                            {t(list["name"])}
                          </Button>
                        )
                      })
                    }
                  
                  </div>
                </td>
              </tr> :
                <Fragment />}
              {categoryType !== "negative" ? <tr>
                <td width={200}>
                  <b>
                    {t("Invisible")} :
                  </b>
                </td>
                <td>
                  <Switch
                    checked={!!invisible}
                    onChange={() => setInvisible(!invisible)}
                    inputProps={{ 'aria-label': 'controlled' }}
                    className={classes.root}
                  />
                </td>
              </tr> :
                <Fragment />}
            </tbody>
          </table>
        </TabPane>
      </TabContent>
    </div>
  )
}
